import {Buffer} from 'buffer';

export function base64ToArrayBuffer(data) {
  const bString = window.atob(data);
  const bLength = bString.length;
  const bytes = new Uint8Array(bLength);
  for (let i = 0; i < bLength; i++) {
    const ascii = bString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export function base64toPDF(data) {
  const bufferArray = base64ToArrayBuffer(data);
  return new Blob([bufferArray], { type: 'application/pdf' });
}
export function base64toImage(data) {
  const splitted = data.split(',');
  const bufferArray = base64ToArrayBuffer(splitted[1]);
  return new Blob([bufferArray], { type: data.type });
}
export const base64ToBuffer = (base64) => {
    const splitted = base64.split(",");
    return Buffer.from(splitted[1], "base64");
}
export const fileToBase64 = (data) => new Promise((resolve, reject) =>{
  const reader = new FileReader();
  reader.readAsDataURL(data);
  reader.onload = (e) => {
    resolve(e.target.result)
  }
})